export default __webpack_public_path__ + "static/media/caso_4_2.1cd47066.jpg";